"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberWithCommas = (number) => {
    if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/utils/number.ts
// module id = 250
// module chunks = 0